// ** Third Party Components
import styled from "styled-components";

// ** Custom Components
import BasicButton from "components/base/Button";

// #####################################################

export const StyledEmojiButton = styled(BasicButton)`
	cursor: pointer;
	padding: 2.5px;
	margin: 0.2rem;
	font-size: 1.4rem;
	border-radius: 50%;
	&:hover {
		background-color: ${({ theme: { colors } }) => colors.itemsHover};
	}
`;

// #####################################################
